import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useCallback, useMemo, useRef } from "react";
import Select from "react-select";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { trackEvent } from "services/bigbrain-service";
import { PRICING_PAGE_SEAT_DROPDOWN_OPENED } from "constants/bigbrain-event-types";
import { UNIT_OF_MEASURE_LABELS, UNIT_OF_MEASURE_SELECTOR_LABELS } from "segments/desktop/pricing/constants";
import { StyledUsersSelect } from "./users-select-component.scss";
export const UsersSelect = ({ usersCountArray, updateSelectedUserCountCallback, productName, defaultSeatsIndex, unitOfMeasure })=>{
    const selectRef = useRef(null);
    const { translate } = useContext(GenericConfigContext);
    const options = useMemo(()=>Object.entries(usersCountArray).map(([label, value])=>{
            return {
                label: `${label} ${translate(UNIT_OF_MEASURE_LABELS[unitOfMeasure])}`,
                value
            };
        }), [
        usersCountArray,
        translate,
        unitOfMeasure
    ]);
    const onFocus = useCallback(()=>{
        var _selectRef_current_state_value, _selectRef_current_state, _selectRef_current;
        const selectedOption = selectRef === null || selectRef === void 0 ? void 0 : (_selectRef_current = selectRef.current) === null || _selectRef_current === void 0 ? void 0 : (_selectRef_current_state = _selectRef_current.state) === null || _selectRef_current_state === void 0 ? void 0 : (_selectRef_current_state_value = _selectRef_current_state.value) === null || _selectRef_current_state_value === void 0 ? void 0 : _selectRef_current_state_value.value;
        trackEvent(PRICING_PAGE_SEAT_DROPDOWN_OPENED, {
            info2: selectedOption,
            productKind: productName
        });
    }, [
        productName
    ]);
    const onSelectionChange = useCallback(({ value })=>{
        updateSelectedUserCountCallback(value);
    }, [
        updateSelectedUserCountCallback
    ]);
    return /*#__PURE__*/ _jsxs(StyledUsersSelect, {
        className: "users-select",
        children: [
            translate(UNIT_OF_MEASURE_SELECTOR_LABELS[unitOfMeasure]),
            /*#__PURE__*/ _jsx(Select, {
                ref: selectRef,
                name: "billing-users-selection",
                className: "billing-users-selection",
                isClearable: false,
                isSearchable: false,
                onChange: onSelectionChange,
                defaultValue: options[defaultSeatsIndex],
                options: options,
                "aria-labelledby": "usersSelectLabel",
                onFocus: onFocus
            })
        ]
    });
};
